const popupOverlay = ID["popup-overlay"];
if (popupOverlay) {
    popupOverlay.addEventListener('click', (e) => {
        popupOverlay.style.display = "none";

        let cookieName = "popupBannersB2C";
        if (e.target.dataset.userAccess === 'B2B') {
            cookieName = "popupBannersB2B";

        }

        const date = new Date();
        date.setTime(date.getTime() + (e.target.dataset.hours*60*60*1000))
        document.cookie = cookieName + "=true;expires=" + date.toUTCString() + ";path=/";

    });
}